import React from 'react';
import { MYPAGE_REVIEW_MENU } from '../../lib/routes/MyPageRoutes';

import { Flex } from '../common/atom/Layout';
import { Text } from '../common/atom/Text';
import { EmptyMessage } from '../common/organism/EmptyMessage';

import ReviewListItem from './ReviewListItem';

const ReviewList = ({ userReviews, totalLikes, setIsFirstTab }) => {
  return (
    <Flex column padding="1.875rem 0 0 0">
      <Flex column>
        <Text size={16} lineHeight={'1.25rem'}>
          고객님이 작성해주신 <b>{userReviews.length}개</b>의 리뷰가
        </Text>
        <Text size={16} lineHeight={'1.25rem'}>
          <b>{totalLikes}명</b>의 엄마 아빠들에게 도움을 주었습니다.
        </Text>
      </Flex>
      <Flex width="100%" column>
        {userReviews.length > 0 ? (
          <Flex column padding="1.25rem">
            {userReviews.map((userReview) => (
              <ReviewListItem
                key={userReview.id}
                id={userReview.id}
                createDateTime={userReview.createDateTime}
                text={userReview.text}
                blogUrl={userReview.blogUrl}
                communityUrl={userReview.communityUrl}
                facebookUrl={userReview.facebookUrl}
                instagramUrl={userReview.instagramUrl}
                facetImage={userReview.facetImage}
                star={userReview.star}
                likesCount={userReview.likesCount}
                purchasedDate={userReview.purchasedItemInfo.createDateTime}
                itemName={userReview.purchasedItemInfo.itemName}
                thumbnail={userReview.reviewCategory.thumbnail.storageUri}
                reviewType={userReview.reviewCategory.name}
              />
            ))}
          </Flex>
        ) : (
          <EmptyMessage
            messageList={[
              '아직 작성한 리뷰가 없습니다.',
              '리뷰 작성하고 페이백 받아보세요!',
            ]}
            buttonTitle="리뷰 작성하러 가기"
            buttonPath={MYPAGE_REVIEW_MENU.path}
            buttonClickEvent={setIsFirstTab}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default ReviewList;
